"use client";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Item, ItemContent, ItemTitle } from "@/components/ui/item";
import { UI } from "@/constants";
import { OrderDetailsType } from "@/types";
import { HTMLAttributes } from "react";
import { Bar, BarChart, CartesianGrid, LabelList, XAxis } from "recharts";

const chartConfig = {
  items: {
    label: UI.labels.items,
  },
} satisfies ChartConfig;

type OrderDetailsChartProps = HTMLAttributes<HTMLDivElement> & {
  orderDetails: OrderDetailsType;
};

export const OrderDetailsChart = ({ orderDetails, ...props }: OrderDetailsChartProps) => {
  if (!orderDetails) return;

  const chartData = [
    {
      label: UI.labels.sharesTotal,
      items: orderDetails.sharesTotal,
      fill: "var(--chart-1)",
    },
    {
      label: UI.labels.sharedProductsTotal,
      items: orderDetails.sharedProductsTotal,
      fill: "var(--chart-2)",
    },
    { label: UI.labels.productsAdded, items: orderDetails.productsAdded, fill: "var(--chart-3)" },
    {
      label: UI.labels.productsRemoved,
      items: orderDetails.productsRemoved,
      fill: "var(--chart-4)",
    },
    {
      label: UI.labels.productsTotal,
      items: orderDetails.productsTotal,
      fill: "var(--chart-5)"
    },
  ];

  return (
    <Item variant="outline" {...props} className="items-start">
      <ItemContent className="size-full justify-between">
        <ItemTitle>{UI.titles.performanceChart}</ItemTitle>
        <ChartContainer config={chartConfig}>
          <BarChart accessibilityLayer data={chartData} margin={{ top: 24 }}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="label" hide />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar dataKey="items" fill="var(--chart-5)" radius={4}>
              <LabelList position="top" offset={12} className="fill-foreground" fontSize={12} />
            </Bar>
          </BarChart>
        </ChartContainer>
      </ItemContent>
    </Item>
  );
};
